<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        数交会 | 大连海大智龙科技有限公司产品大放异彩
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2021-07-22</span
        ><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line divcss5"></div>
      <div class="div-row div-bottom10">
        <p class="indentation">
          7月22日，以“数字服务创新未来”为主题的2021中国数交会在大连世界博览广场拉开帷幕中国数交会是中国软交会的全面升级，
          是国内软件行业唯一的国家级展会，已连续成功举办十余届，是国内规格高、规模最大、影响力最强的IT行业年度盛会。
        </p>
        <div class="div-row div-bottom10">
          <div class="div-top box2">
            <div class="div-margin">
              <img src="../../../assets/images/news25/logo.jpg" />
            </div>
          </div>
        </div>
        <br />
        <p class="indentation">
          本届数交会，大连海大智龙科技有限公司以“智能交通智慧海洋”为主题，展示了本公司自主研发的VR设备，无人艇等产品。展会现场，智龙产品以其寓教于乐，操作智能等特点获得了现场观众的一致好评。
        </p>

        <div class="div-row div-bottom10">
          <div class="div-top box2">
            <div class="div-margin">
              <img src="../../../assets/images/news25/1.jpg" />
            </div>
          </div>
        </div>
        <div class="div-row div-bottom10">
          <div class="div-top box2">
            <div class="div-margin">             
              <img src="../../../assets/images/news25/2.jpg" />
            </div>
          </div>
        </div>
        <br />
        <p class="indentation">
          商务部副部长王炳南，大连市市委书记胡玉亭，市长陈绍旺等领导也对智龙产品给与了充分肯定与高度评价。
        </p>
        <div class="div-row div-bottom10">
          <div class="div-top box2">
            <div class="div-margin">
              <img src="../../../assets/images/news25/3.jpg" />
            </div>
          </div>
        </div>

        <div class="div-row div-bottom10">
          <div class="div-top box2">
            <div class="div-margin">
              <img src="../../../assets/images/news25/4.jpg" />
            </div>
          </div>
        </div>
        <br />
        <p class="indentation">
          带着参会观众的喜爱和领导的厚爱，大连海大智龙科技有限公司将会一如既往为客户提供优质服务，为智能交通和智慧海洋提供高科技智能化产品，为国家交通强国，海洋强国，“海上丝绸之路”战略提供技术支撑。
        </p>
        <p class="indentation">联系电话：0411-84978997</p>
        <p class="indentation" style="text-align: right">
          大连海大智龙科技有限公司<br />
          2021年7月22日
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.fl {
  float: right;
  margin-right: 20px;
}

.fy {
  text-align: center;
  margin-top: 30px;
}

.title {
  height: 100%;
}

.div-width {
  width: 75%;
}

.div-line {
  background: #e6e6e6;
  height: 1px;
  width: 100%;
}

.div-bottom10 {
  padding-top: 10px;
}

.div-bottom30 {
  padding-top: 30px;
  padding-bottom: 30px;
}

.div-top30 {
  padding-top: 30px;
}

img {
    vertical-align: middle;
    border-style: none;
    width: 95%;
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2021/news25.vue